var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style["m-presence"] }, [
    _c("div", { staticClass: "m-container" }, [
      _c("div", { class: _vm.$style["container-inner"] }, [
        _c("div", { class: _vm.$style["presence-list"] }, [
          _c(
            "div",
            {
              staticClass: "flex justify-center",
              class: _vm.$style["module-head"]
            },
            [
              _c("div", { class: _vm.$style["module-info"] }, [
                _c(
                  "h2",
                  {
                    staticClass: "enter-animate animate__fadeInUp",
                    class: _vm.$style["module-title"]
                  },
                  [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(_vm.$t("300238")) +
                          "\n                  "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass: "enter-animate animate__fadeInUp",
                    class: _vm.$style["module-subtitle"]
                  },
                  [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("300239")) +
                          "\n              "
                      )
                    ])
                  ]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "enter-animate animate__fadeIn",
              class: _vm.$style["module-body"],
              style: {
                animationDelay: "0.2s"
              }
            },
            [
              _c("div", { class: _vm.$style["module-data"] }, [
                _c(
                  "div",
                  { staticClass: "flex", class: _vm.$style["tab-bar"] },
                  [
                    _vm._l(_vm.presenceList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          ref: "tabItems",
                          refInFor: true,
                          class: _vm.$style["tab-item"],
                          on: {
                            click: function($event) {
                              return _vm.goTo(index)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "text" }, [
                            _vm._v(_vm._s(_vm.$t(item.key)))
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", {
                      ref: "moveShadow",
                      class: _vm.$style["move-shadow"]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { class: _vm.$style["presence-list"] }, [
                  _c(
                    "div",
                    {
                      ref: "swiperDom",
                      staticClass: "swiper",
                      class: _vm.$style["swiper"]
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "swiper-wrapper" },
                        _vm._l(_vm.presenceList, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "swiper-slide" },
                            [
                              _c(
                                "div",
                                {
                                  ref: "listItems",
                                  refInFor: true,
                                  class: _vm.$style["list-item"]
                                },
                                [
                                  _c(
                                    "div",
                                    { class: _vm.$style["list-item--inner"] },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex justify-center items-center",
                                          class: _vm.$style["item-icon"]
                                        },
                                        [
                                          _c("svg-icon", {
                                            class: _vm.$style["icon"],
                                            attrs: { "icon-class": item.icon }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { class: _vm.$style["item-info"] },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "grid grid-flow-col-dense items-center",
                                              class: _vm.$style["item-head"]
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    _vm.$style["item-title"]
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "text" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(item.title)
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          ref: "lightBox",
                                          refInFor: true,
                                          class: _vm.$style["light-box"]
                                        },
                                        [
                                          _c("div", {
                                            class: _vm.$style["light-l"]
                                          }),
                                          _vm._v(" "),
                                          _c("div", {
                                            class: _vm.$style["light-r"]
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { class: _vm.$style["item-desc"] },
                                        [
                                          _c("span", { staticClass: "text" }, [
                                            _vm._v(_vm._s(_vm.$t(item.desc)))
                                          ])
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-90bc2ce4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90bc2ce4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/newHome/index/PresenceModule.vue
// module id = o+Zn
// module chunks = 0